import React from "react";

const AboutUs = () => {
  return (
    <div>
      <h1 classNam="pt-24 text-5xl">About US</h1>
    </div>
  );
};

export default AboutUs;
